import { useTranslation } from "react-i18next";
import { Moon } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

export const QuietHoursControls = ({ prefs, setPrefs, disabled }) => {
  const { t } = useTranslation();
  const set = (patch) => setPrefs((p) => ({ ...p, ...patch }));
  return (
    <div className="space-y-2 py-2 border-t border-slate-100" data-testid="quiet-hours-section">
      <div className="flex items-center justify-between gap-4">
        <div>
          <p className="text-sm font-medium text-slate-800 flex items-center gap-2"><Moon className="w-3.5 h-3.5" /> {t("phoneAlerts.quietHours")}</p>
          <p className="text-xs text-slate-400">{t("phoneAlerts.quietHint")}</p>
        </div>
        <Switch data-testid="quiet-hours-toggle" aria-label={t("phoneAlerts.quietHours")} disabled={disabled} checked={prefs.quiet_enabled}
          onCheckedChange={(v) => set({ quiet_enabled: v, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC" })} />
      </div>
      {prefs.quiet_enabled && (
        <div className="flex flex-wrap items-end gap-3">
          <label className="text-xs text-slate-600 space-y-1">
            <span className="block">{t("phoneAlerts.quietFrom")}</span>
            <Input data-testid="quiet-hours-start" type="time" className="rounded-sm w-32" value={prefs.quiet_start} onChange={(e) => set({ quiet_start: e.target.value })} />
          </label>
          <label className="text-xs text-slate-600 space-y-1">
            <span className="block">{t("phoneAlerts.quietTo")}</span>
            <Input data-testid="quiet-hours-end" type="time" className="rounded-sm w-32" value={prefs.quiet_end} onChange={(e) => set({ quiet_end: e.target.value })} />
          </label>
          <span className="text-[11px] text-slate-400 pb-2" data-testid="quiet-hours-timezone">{prefs.timezone}</span>
        </div>
      )}
      {prefs.held_count > 0 && <p className="text-xs text-indigo-700" data-testid="quiet-hours-held">{t("phoneAlerts.held", { count: prefs.held_count })}</p>}
    </div>
  );
};
